import { render, staticRenderFns } from "./IconAddNew.vue?vue&type=template&id=bb08e862&scoped=true"
import script from "./IconAddNew.vue?vue&type=script&lang=js"
export * from "./IconAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb08e862",
  null
  
)

export default component.exports